import { put } from "redux-saga/effects";

import * as action from "../action";

export default function* ({ payload: { ready_list } }) {
  yield put(action.readyListReceived(ready_list));
}
